import { render, staticRenderFns } from "./footer_badges.vue?vue&type=template&id=4863d28a&scoped=true"
import script from "./footer_badges.vue?vue&type=script&lang=js"
export * from "./footer_badges.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4863d28a",
  null
  
)

export default component.exports